import M from 'messages';

const ColorsMap = {
  allWines: '#CE5C5C',
  visits: '#00BFFF',
  views: '#c95ff5',
  averageRating: '#82B796',
  ratings: '#3CB371',
  saves: '#FFC300',
  buys: '#FF6347',
};

const LineChartConfig = [
  {
    title: M.get('dashboard.lineChart.visits'),
    key: 'visits',
    color: ColorsMap.visits,
  },
  {
    title: M.get('dashboard.lineChart.views'),
    key: 'views',
    color: ColorsMap.views,
  },
  {
    title: M.get('dashboard.lineChart.ratings'),
    key: 'ratings',
    color: ColorsMap.ratings,
  },
  {
    title: M.get('dashboard.lineChart.saves'),
    key: 'saves',
    color: ColorsMap.saves,
  },
  {
    title: M.get('dashboard.lineChart.buys'),
    key: 'buys',
    color: ColorsMap.buys,
  },
];

export { LineChartConfig, ColorsMap };
